export const ENDPOINTS = {
  settings: 'user/get-settings',
};
